import * as v from 'valibot';
import { BoundarySchema } from './boundary.types';

// This is an experimental use of Valibot for runtime schema validation and type inference
// hey-api also supports valibot, so in the final cut I expect these will be defined in the
// generated hey-api code, but this is TBD.

export const ExclusionZoneResponseSchema = v.object({
  exclusions: v.array(BoundarySchema),
});

export type ExclusionsResponse = v.InferOutput<
  typeof ExclusionZoneResponseSchema
>;
